export const GET_STAGE = "GET_STAGE"
export const SET_STAGE = "SET_STAGE"
export const CHANGE_POPUP = "CHANGE_POPUP"
export const ADD_TASK = "ADD_TASK"
export const DELETE_TASK = "DELETE_TASK"
export const EDIT_TASK = "EDIT_TASK"
export const CLOSE_ALERT = "CLOSE_ALERT"
